import { render, staticRenderFns } from "./UserManagementLocal.vue?vue&type=template&id=36ec791c&scoped=true"
import script from "./UserManagementLocal.vue?vue&type=script&lang=ts"
export * from "./UserManagementLocal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec791c",
  null
  
)

export default component.exports